import { CFormGroup, CInput, CInvalidFeedback, CLabel } from "@coreui/react";

import React from "react";
import { FieldError } from "react-hook-form";

interface NumberFieldProps {
  name: string;
  label: string;
  description?: string;
  value: number;
  onChange: (value: number) => void;
  error?: FieldError;
  required?: boolean;
  placeholder?: string;
  min?: number;
  max?: number;
  step?: number;
  testId?: string;
}

const NumberField: React.FC<NumberFieldProps> = ({
  name,
  label,
  description,
  value,
  onChange,
  error,
  required = false,
  placeholder,
  min,
  max,
  step = 1,
  testId,
}) => {
  return (
    <CFormGroup>
      <CLabel htmlFor={name}>
        {label}
        {required && <span className="text-danger"> *</span>}
      </CLabel>
      {description && (
        <small className="form-text text-muted mb-2">{description}</small>
      )}
      <CInput
        id={name}
        name={name}
        data-testid={testId}
        type="number"
        value={value}
        onChange={(e) => onChange(Number((e.target as HTMLInputElement).value))}
        placeholder={placeholder}
        invalid={!!error}
        min={min}
        max={max}
        step={step}
      />
      {error && <CInvalidFeedback>{error.message}</CInvalidFeedback>}
    </CFormGroup>
  );
};

export default NumberField;
